/* eslint-disable max-len */
import React from 'react';

export const UnexpectedErrorTwoSVG = () => (
  <svg
    width="240"
    height="250"
    viewBox="0 0 240 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Unexpected error illustration"
  >
    <mask
      id="mask0_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="45"
      y="3"
      width="161"
      height="206"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.9321 3.19949H205.271V208.516H45.9321V3.19949Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.1859 206.898L90.3564 131.764H70.0994L66.2699 206.898H94.1859ZM61.5318 208.516C57.0896 208.516 53.4891 204.91 53.4891 200.461V208.516H61.5318ZM155.386 206.898L155.296 131.764H135.039L134.949 206.898H155.386ZM130.161 208.516C125.719 208.516 122.118 204.91 122.118 200.461V208.516H130.161ZM196.443 28.9951C202.054 28.9951 206.6 33.548 206.6 39.1669V197.793C206.6 203.412 202.054 207.965 196.443 207.965H61.5318C55.9206 207.965 51.3748 203.412 51.3748 197.793V39.1669C51.3748 33.548 55.9206 28.9951 61.5318 28.9951H196.443ZM196.443 3.19949H61.5318C54.2438 3.19949 45.9321 8.32844 45.9321 16.9334V208.516H53.4891H61.5318H66.2699H90.3564H94.1859H122.118H130.161H134.949H135.039H155.386H205.271V16.9334C205.271 8.32844 196.959 3.19949 189.671 3.19949H196.443Z"
        fill="black"
      />
    </g>
    <mask
      id="mask1_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="150"
      width="155"
      height="68"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 150.567H154.622V217.31H0.119873V150.567Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-85.9407 217.31C-85.9407 178.103 -81.7326 159.95 -79.7088 153.488C-79.1659 151.753 -77.547 150.567 -75.7086 150.567H143.071C144.901 150.567 146.523 151.74 147.065 153.466C149.085 159.909 153.303 178.059 153.303 217.31H-85.9407Z"
        fill="#47C2BB"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M132.636 155.609H115.4C110.433 155.609 105.938 158.69 103.978 163.447C100.421 172.086 98.5684 181.416 98.5684 190.878V218.03H149.468V190.878C149.468 181.416 147.615 172.086 144.057 163.447C142.098 158.69 137.603 155.609 132.636 155.609Z"
      fill="#0E9D97"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.1308 155.609H55.8944C50.9271 155.609 46.4328 158.69 44.4731 163.447C40.9153 172.086 39.063 181.416 39.063 190.878V218.03H89.9622V190.878C89.9622 181.416 88.1099 172.086 84.5519 163.447C82.5924 158.69 78.0978 155.609 73.1308 155.609Z"
      fill="#0E9D97"
    />
    <mask
      id="mask2_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="155"
      width="28"
      height="64"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 155.609H27.3403V218.03H0.119873V155.609Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.509 155.609H-6.72739C-11.6947 155.609 -16.189 158.69 -18.1488 163.447C-21.7067 172.086 -23.5588 181.416 -23.5588 190.878V218.03H27.3402V190.878C27.3402 181.416 25.4881 172.086 21.9301 163.447C19.9706 158.69 15.476 155.609 10.509 155.609Z"
        fill="#0E9D97"
      />
    </g>
    <mask
      id="mask3_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="213"
      width="155"
      height="7"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 213.708H154.622V219.23H0.119873V213.708Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.416 216.349C107.636 216.349 94.2112 213.708 94.2112 213.708C94.2112 213.708 80.7867 216.349 64.0061 216.349C47.2255 216.349 33.801 213.708 33.801 213.708C33.801 213.708 20.3765 216.349 3.59586 216.349C-13.1848 216.349 -26.6093 213.708 -26.6093 213.708C-26.6093 213.708 -40.0338 216.349 -56.8144 216.349C-67.176 216.349 -76.2579 215.491 -81.69 214.65C-84.4931 214.217 -87.0195 216.39 -87.0195 219.23H154.622C154.622 216.39 152.095 214.217 149.292 214.65C143.86 215.491 134.778 216.349 124.416 216.349Z"
        fill="#47C2BB"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.5318 28.9954H196.443C202.054 28.9954 206.6 33.5484 206.6 39.1672V197.793C206.6 203.412 202.054 207.965 196.443 207.965H61.5318C55.9206 207.965 51.3748 203.412 51.3748 197.793V39.1672C51.3748 33.5484 55.9206 28.9954 61.5318 28.9954Z"
      fill="#697079"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M196.443 207.965H61.5318C55.9206 207.965 51.3748 203.412 51.3748 197.793V39.1672C51.3748 33.5484 55.9206 28.9954 61.5318 28.9954H196.443C202.054 28.9954 206.6 33.5484 206.6 39.1672V197.793C206.6 203.412 202.054 207.965 196.443 207.965ZM61.5318 24.8094C53.6758 24.8094 47.3019 31.1935 47.3019 39.1672V197.793C47.3019 205.767 53.6758 212.151 61.5318 212.151H196.443C204.299 212.151 210.673 205.767 210.673 197.793V39.1672C210.673 31.1935 204.299 24.8094 196.443 24.8094H61.5318Z"
      fill="#3B3F41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.5318 34.3188H196.443C198.9 34.3188 200.886 36.3111 200.886 38.7738V198.186C200.886 200.649 198.9 202.641 196.443 202.641H61.5318C59.0741 202.641 57.0889 200.649 57.0889 198.186V38.7738C57.0889 36.3111 59.0741 34.3188 61.5318 34.3188Z"
      fill="#9870B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.5318 34.3188H196.443C198.9 34.3188 200.886 36.3111 200.886 38.7738V198.186C200.886 200.649 198.9 202.641 196.443 202.641H61.5318C59.0741 202.641 57.0889 200.649 57.0889 198.186V38.7738C57.0889 36.3111 59.0741 34.3188 61.5318 34.3188Z"
      fill="#0383A4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.987 15.4861C123.396 15.4861 118.861 19.7092 118.861 24.895V27.1049H139.113V24.895C139.113 19.7092 134.578 15.4861 128.987 15.4861Z"
      fill="#3B3F41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.987 17.4771C126.563 17.4771 124.598 19.4471 124.598 21.8766V24.6906H133.376V21.8766C133.376 19.4471 131.411 17.4771 128.987 17.4771Z"
      fill="#697079"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5796 45.5615C63.8916 45.5615 62.5229 46.9344 62.5229 48.6275V56.4026C62.5229 58.0955 63.8916 59.4687 65.5796 59.4687H87.9969C89.6847 59.4687 91.0536 58.0955 91.0536 56.4026V48.6275C91.0536 46.9344 89.6847 45.5615 87.9969 45.5615H65.5796Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.151 45.5615C108.463 45.5615 107.094 46.9344 107.094 48.6275V56.4026C107.094 58.0955 108.463 59.4687 110.151 59.4687H192.397C194.085 59.4687 195.454 58.0955 195.454 56.4026V48.6275C195.454 46.9344 194.085 45.5615 192.397 45.5615H110.151Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5796 65.9937C63.8916 65.9937 62.5229 67.3667 62.5229 69.0598V76.8349C62.5229 78.5278 63.8916 79.901 65.5796 79.901H143.842C145.53 79.901 146.899 78.5278 146.899 76.8349V69.0598C146.899 67.3667 145.53 65.9937 143.842 65.9937H65.5796Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.995 65.9937C165.307 65.9937 163.938 67.3667 163.938 69.0598V76.8349C163.938 78.5278 165.307 79.901 166.995 79.901H192.397C194.085 79.901 195.454 78.5278 195.454 76.8349V69.0598C195.454 67.3667 194.085 65.9937 192.397 65.9937H166.995Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5796 86.4255C63.8916 86.4255 62.5229 87.7984 62.5229 89.4915V97.2667C62.5229 98.9596 63.8916 100.333 65.5796 100.333H121.562C123.25 100.333 124.619 98.9596 124.619 97.2667V89.4915C124.619 87.7984 123.25 86.4255 121.562 86.4255H65.5796Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M144.716 86.4255C143.028 86.4255 141.659 87.7984 141.659 89.4915V97.2667C141.659 98.9596 143.028 100.333 144.716 100.333H192.397C194.085 100.333 195.454 98.9596 195.454 97.2667V89.4915C195.454 87.7984 194.085 86.4255 192.397 86.4255H144.716Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5796 106.857C63.8916 106.857 62.5229 108.23 62.5229 109.923V117.698C62.5229 119.391 63.8916 120.764 65.5796 120.764H94.5646C96.2526 120.764 97.6213 119.391 97.6213 117.698V109.923C97.6213 108.23 96.2526 106.857 94.5646 106.857H65.5796Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M117.718 106.857C116.03 106.857 114.661 108.23 114.661 109.923V117.698C114.661 119.391 116.03 120.764 117.718 120.764H192.397C194.085 120.764 195.454 119.391 195.454 117.698V109.923C195.454 108.23 194.085 106.857 192.397 106.857H117.718Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5796 127.289C63.8916 127.289 62.5229 128.662 62.5229 130.355V138.13C62.5229 139.823 63.8916 141.196 65.5796 141.196H179.843C181.531 141.196 182.9 139.823 182.9 138.13V130.355C182.9 128.662 181.531 127.289 179.843 127.289H65.5796Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5796 147.721C63.8916 147.721 62.5229 149.094 62.5229 150.787V158.562C62.5229 160.255 63.8916 161.628 65.5796 161.628H135.913C137.601 161.628 138.97 160.255 138.97 158.562V150.787C138.97 149.094 137.601 147.721 135.913 147.721H65.5796Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.066 147.721C157.378 147.721 156.009 149.094 156.009 150.787V158.562C156.009 160.255 157.378 161.628 159.066 161.628H192.397C194.085 161.628 195.454 160.255 195.454 158.562V150.787C195.454 149.094 194.085 147.721 192.397 147.721H159.066Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5796 168.152C63.8916 168.152 62.5229 169.526 62.5229 171.219V178.994C62.5229 180.687 63.8916 182.06 65.5796 182.06H108.407C110.095 182.06 111.464 180.687 111.464 178.994V171.219C111.464 169.526 110.095 168.152 108.407 168.152H65.5796Z"
      fill="#B1E1F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.56 168.152C129.872 168.152 128.503 169.526 128.503 171.219V178.994C128.503 180.687 129.872 182.06 131.56 182.06H192.397C194.085 182.06 195.454 180.687 195.454 178.994V171.219C195.454 169.526 194.085 168.152 192.397 168.152H131.56Z"
      fill="#B1E1F4"
    />
    <mask
      id="mask4_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="210"
      y="151"
      width="29"
      height="70"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.357 151.567H239V220.23H210.357V151.567Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M235.26 214.708C228.935 214.708 223.427 210.381 221.929 204.227C217.642 186.612 215.52 162.69 214.884 154.476C214.757 152.833 213.388 151.567 211.744 151.567H210.357V220.23H261.658C261.658 217.18 259.19 214.708 256.144 214.708H235.26Z"
        fill="#47C2BB"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.455 214.708C191.779 214.708 197.287 210.381 198.785 204.227C203.072 186.612 205.194 162.69 205.831 154.476C205.958 152.833 207.326 151.567 208.971 151.567H210.357V220.23H159.056C159.056 217.18 161.525 214.708 164.57 214.708H185.455Z"
      fill="#47C2BB"
    />
    <mask
      id="mask5_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="210"
      y="0"
      width="29"
      height="142"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.357 0H238.693V141.565H210.357V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M238.693 133.177C238.693 133.177 238.632 133.177 238.601 133.177H210.357V141.565H238.601C241.694 141.565 244.201 139.052 244.201 135.953V103.631C244.201 111.068 242.105 127.089 238.693 133.177ZM238.601 0H210.357V8.38761H238.693C242.105 14.4759 244.201 30.4967 244.201 37.9336V5.6119C244.201 2.51294 241.694 0 238.601 0Z"
        fill="#10BEF0"
      />
    </g>
    <mask
      id="mask6_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="29"
      height="142"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 0H28.4553V141.565H0.119873V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 133.177C0.119873 133.177 0.180818 133.177 0.211755 133.177H28.4553V141.565H0.211755C-2.88126 141.565 -5.38806 139.052 -5.38806 135.953V103.631C-5.38806 111.068 -3.29233 127.089 0.119873 133.177ZM0.211755 0H28.4553V8.38761H0.119873C-3.29233 14.4759 -5.38806 30.4967 -5.38806 37.9336V5.6119C-5.38806 2.51294 -2.88126 0 0.211755 0Z"
        fill="#10BEF0"
      />
    </g>
    <mask
      id="mask7_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="62"
      y="188"
      width="134"
      height="36"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.5229 188.584H195.454V223.044H62.5229V188.584Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask7_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M195.454 188.584C195.454 188.584 195.393 188.584 195.362 188.584H62.6156V223.044H195.362C198.455 223.044 200.962 220.53 200.962 217.432V194.115C200.962 197.213 199.912 187.836 195.454 188.584ZM62.6156 188.584H62.5229V223.044H62.6156C59.522 223.044 57.0152 220.53 57.0152 217.432V194.115C57.0152 197.213 58.0659 187.836 62.5229 188.584Z"
        fill="#9870B1"
      />
    </g>
    <mask
      id="mask8_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="108"
      y="213"
      width="44"
      height="38"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.029 213.708H151.348V250.43H108.029V213.708Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask8_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M148.591 213.708H111.414C109.492 213.708 107.933 215.271 107.933 217.198V246.94C107.933 248.867 109.492 250.43 111.414 250.43H148.591C150.513 250.43 152.072 248.867 152.072 246.94V217.198C152.072 215.271 150.513 213.708 148.591 213.708Z"
        fill="#F15961"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M148.591 213.708H111.414C109.492 213.708 107.933 215.271 107.933 217.198V246.94C107.933 248.867 109.492 250.43 111.414 250.43H148.591C150.513 250.43 152.072 248.867 152.072 246.94V217.198C152.072 215.271 150.513 213.708 148.591 213.708Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.414 208.516C109.492 208.516 107.933 210.079 107.933 212.006V217.198C107.933 215.271 109.492 213.708 111.414 213.708H148.591C150.513 213.708 152.072 215.271 152.072 217.198V212.006C152.072 210.079 150.513 208.516 148.591 208.516H111.414Z"
      fill="#F15961"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M148.591 208.516H111.414C109.492 208.516 107.933 210.079 107.933 212.006V213.407C107.933 211.48 109.492 209.917 111.414 209.917H148.591C150.513 209.917 152.072 211.48 152.072 213.407V212.006C152.072 210.079 150.513 208.516 148.591 208.516Z"
      fill="#F6915A"
    />
    <mask
      id="mask9_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="115"
      y="221"
      width="18"
      height="22"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.088 221.137H132.425V242.43H115.088V221.137Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask9_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.088 228.529C115.088 224.506 118.373 221.212 122.386 221.212H125.127C129.141 221.212 132.425 224.506 132.425 228.529V242.43H115.088V228.529Z"
        fill="#6A707A"
      />
    </g>
    <mask
      id="mask10_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="126"
      y="221"
      width="19"
      height="22"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.841 221.137H144.177V242.43H126.841V221.137Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask10_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.841 228.529C126.841 224.506 130.126 221.212 134.139 221.212H136.88C140.893 221.212 144.177 224.506 144.177 228.529V242.43H126.841V228.529Z"
        fill="#6A707A"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M123.756 234.224C123.756 232.297 125.316 230.734 127.237 230.734H132.768C134.689 230.734 136.249 232.297 136.249 234.224V242.43H123.756V234.224Z"
      fill="#3B3F41"
    />
    <mask
      id="mask11_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="114"
      y="233"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.461 233.597H131.797V250.43H114.461V233.597Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask11_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.461 241.803C114.461 237.111 118.253 233.31 122.935 233.31H123.323C128.005 233.31 131.797 237.111 131.797 241.803V250.43H114.461V241.803Z"
        fill="#5E3A30"
      />
    </g>
    <mask
      id="mask12_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="128"
      y="233"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.208 233.597H145.544V250.43H128.208V233.597Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask12_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.208 241.803C128.208 237.111 132 233.31 136.682 233.31H137.07C141.752 233.31 145.544 237.111 145.544 241.803V250.43H128.208V241.803Z"
        fill="#5E3A30"
      />
    </g>
    <mask
      id="mask13_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="118"
      y="219"
      width="13"
      height="13"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.202 219.536H130.311V231.661H118.202V219.536Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask13_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.257 219.536C127.609 219.536 130.311 222.245 130.311 225.599C130.311 228.952 127.609 231.661 124.257 231.661C120.905 231.661 118.202 228.952 118.202 225.599C118.202 222.245 120.905 219.536 124.257 219.536Z"
        fill="#B26E4B"
      />
    </g>
    <mask
      id="mask14_1414_6181"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="129"
      y="219"
      width="14"
      height="13"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.694 219.536H141.803V231.661H129.694V219.536Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask14_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.749 219.536C139.101 219.536 141.803 222.245 141.803 225.599C141.803 228.952 139.101 231.661 135.749 231.661C132.397 231.661 129.694 228.952 129.694 225.599C129.694 222.245 132.397 219.536 135.749 219.536Z"
        fill="#B26E4B"
      />
    </g>
  </svg>
);
